module.exports = __webpack_public_path__ + "static/media/team-squid.84be3b60.svg";